import { CSSProperties } from 'react';
import { FelaCSS } from '../../../components/fela/flowtypes';
import { colors } from '../../../themes/variables';

interface IStyles {
  bar: (
    height: number,
    backgroundColor: string,
    borderColor: string,
    showMarkers: boolean,
  ) => CSSProperties;
  chapterMarker: (chapterWidth: number, left: string) => CSSProperties;
  chapterValueWrapper: CSSProperties;
  chapterValue: (height: number) => FelaCSS;
  progressStyle: (
    color: string,
    progressWidth: string,
    progressEqualsChapter?: boolean,
  ) => CSSProperties;
  progressMarker: (color: string) => FelaCSS;
  labelsWrapper: CSSProperties;
  labelValue: FelaCSS;
  label: FelaCSS;
}

const styles = (): IStyles => ({
  bar: (height, backgroundColor, borderColor, showMarkers) => ({
    height,
    borderRadius: '10px',
    backgroundColor,
    position: 'relative',
    width: '100%',
    ...(!showMarkers && {
      overflow: 'hidden',
    }),
    ...(borderColor && {
      border: `1px solid ${borderColor}`,
    }),
  }),
  chapterMarker: (chapterWidth, left) => ({
    position: 'absolute',
    height: '100%',
    width: chapterWidth || 4,
    left: `calc(${left} - ${chapterWidth || 4}px)`,
    backgroundColor: 'white',
    zIndex: 3,
  }),
  chapterValueWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 16,
    justifyContent: 'center',
  },
  chapterValue: (height) => ({
    paddingTop: `${height}px`,
    justifyContent: 'center',
    fontDefaultSemiBold: 12,
  }),
  progressStyle: (color, progressWidth, progressEqualsChapter) => ({
    height: '100%',
    backgroundColor: color,
    width: progressWidth,
    transition: 'width 0.5s ease-in-out, border-radius 0.5s ease-in-out',
    willChange: 'width',
    position: 'absolute',
    top: 0,
    left: 0,
    alignItems: 'center',
    display: 'flex',
    borderBottomRightRadius: progressEqualsChapter ? '0px' : '10px',
    borderTopRightRadius: progressEqualsChapter ? '0px' : '10px',
    borderBottomLeftRadius: '10px',
    borderTopLeftRadius: '10px',
  }),
  progressMarker: (color) => ({
    left: 'calc(100% - 15px)',
    position: 'absolute',
    fontDefault: 12,
    color: colors.white,
    lineHeight: '150%',
    backgroundColor: color,
    borderRadius: '50%',
    paddingVertical: 1,
    textAlign: 'center',
    borderWidth: 2,
    borderColor: 'white',
    borderStyle: 'solid',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.15)',
    zIndex: 5,
    width: 30,
  }),
  labelsWrapper: {
    display: 'flex',
    width: 'calc(100% + 9px)',
    justifyContent: 'space-between',
    paddingTop: 16,
    paddingRight: 0,
  },
  labelValue: {
    textAlign: 'right',
    fontDefaultSemiBold: 12,
  },
  label: {
    fontDefault: 12,
  },
});

export default styles;
